import { useCallback, useEffect, useMemo, useState } from "react";

// Material UI Styling
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useDispatch } from "react-redux";

import { Button, Grid } from "@mui/material";
import { IBaseContent, IContentType, IFullFlight } from "@vmosolutions/oc-interfaces";
import { getContentTypes } from "src/redux/actions/ContentManagement/ContentManagement.Actions";
import { openWindow } from "src/redux/actions/Mosaic.Actions";
import { ContentTree } from "./ContentTree";

const mapContent = (contentOnEvent: IBaseContent[], fetchedContentTypes: any[]): ISortedContent => {
  const mappedContent: ISortedContent = {};
  fetchedContentTypes.forEach((each: IContentType) => {
    mappedContent[each._id] = [];
  });
  // Sort all content by createdAt in descending order to show most recent at the top
  contentOnEvent.sort((a, b) => b.createdAt - a.createdAt);
  contentOnEvent.forEach((each: IBaseContent) => {
    if (mappedContent[each?.contentType?._id]) {
      mappedContent[each.contentType._id].push(each);
    } else mappedContent[each?.contentType?._id] = [each];
  });
  return mappedContent;
};

export interface ISortedContent {
  [contentTypeId: string]: IBaseContent[];
}

export interface IDisplayContentProps {
  flightId: string;
  path: string[];
  windowId?: string;
  content?: IBaseContent[];
  flight: IFullFlight;
  setLoadedEvent?: any;
}

export const DisplayContent = (props: IDisplayContentProps): JSX.Element => {
  const dispatch = useDispatch();

  const { flightId, path, content, flight, setLoadedEvent } = props;

  const [contentTypes, setContentTypes] = useState<IContentType[]>(null);

  const mappedContent = useMemo(() => {
    if (content && contentTypes) {
      return mapContent(content, contentTypes);
    }
    return null;
  }, [contentTypes, content]);

  useEffect(() => {
    const getTypes = async (): Promise<void> => {
      const types = await getContentTypes();
      const fltContentOnly = types.filter((type) => type.associationType === "Flight");
      setContentTypes(fltContentOnly);
    };
    getTypes();
  }, []);

  const handleAddContent = useCallback(
    (event: any): void => {
      //open a new tab, "add content"
      dispatch(
        openWindow(
          "Create Content",
          "ManageContentWindow",
          [],
          {
            injectedFlights: [flight],
            initialSelectedFlightId: flightId,
            setLoadedEvent: setLoadedEvent,
          },
          "context"
        )
      );
    },
    [dispatch, flight, flightId, setLoadedEvent]
  );

  ////////////
  // return //
  ////////////
  return (
    <Grid container>
      <Grid item xs={12} sx={{ display: "flex", justifyContent: "end" }}>
        <Button
          id={"add_content"}
          variant="contained"
          onClick={handleAddContent}
          size="small"
          sx={{ px: 1, py: 0.25, my: 1, mr: 1 }}
          startIcon={<OpenInNewIcon />}
        >
          Add Content
        </Button>
      </Grid>
      <Grid item xs={12}>
        {mappedContent && (
          <ContentTree
            content={mappedContent}
            path={path}
            flight={flight}
            flightId={flightId}
            contentTypes={contentTypes}
            setLoadedEvent={setLoadedEvent}
          />
        )}
      </Grid>
    </Grid>
  );
};
